import { Injectable, inject } from '@angular/core';
import { Resolve } from '@angular/router';
import { filter, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { ClientSegmentFacadeService } from '../services/client-segment-observer/client-segment.service';
import { Store } from '@ngrx/store';
import { selectClientSegmentContent } from '../store/selectors/account-permissions.selector';
import { PUBLIC_ROUTES } from '../constants/application-routes';
import { Location } from '@angular/common';

@Injectable({
    providedIn: 'root',
})
export class ClientSegmentResolver implements Resolve<void> {
    private readonly clientSegmentFacadeService = inject(ClientSegmentFacadeService);
    private readonly store = inject(Store);
    private readonly location = inject(Location);


    resolve() {
        const currentPageUrl = this.location.path();
        const publicRoutesArray = Object.values(PUBLIC_ROUTES);

        const isPublicFlow = this.isPublicRoute(currentPageUrl, publicRoutesArray);
        return isPublicFlow
            ? this.setDefaultClientSegmentAsObservable()
            : this.getClientSegment();
    }

    private isPublicRoute(currentPageUrl: string, publicRoutes: string[]): boolean {
        return publicRoutes.some((route) =>
            currentPageUrl.includes(route.replace(':token', ''))
        );
    }

    private setDefaultClientSegmentAsObservable(): Observable<void> {
        this.clientSegmentFacadeService.setDefaultClientSegment();
        return of(undefined);
    }

    getClientSegment(): Observable<void> {
        this.clientSegmentFacadeService.loadClientSegmentContent();
        return this.store.select(selectClientSegmentContent).pipe(
            filter((data) => data.hasLoaded),
            map(() => undefined),
        );
    }
}
